// Generated by @kazoohr/webpack

import Component from "/home/circleci/project/build/combinedRoutes";
import { browserEntry } from "@kazoohr/entrypoint";

browserEntry(Component);
